import BaseEntity from './BaseEntity'

const Props = {
  id: undefined,
  name: undefined,
  avatarImageUrl: undefined,
  dateOfBirth: undefined,
  gender: undefined,
  danceKind: undefined,
  experience: undefined,
}

class Student extends BaseEntity {
  get fullName() {
    return this.displayName || [this.lastName, this.firstName].join(' ') || name
  }
}

export default function createStudent(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Student(attr))
}
